import Model from "./Model";
import { ProductSector, ProductCategory, ProductClass } from ".";

export default class UserTaxonomy extends Model {
  static type = "userTaxonomies";

  taxonomy?: ProductSector | ProductCategory | ProductClass | undefined;
}
